import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Principal (PDF):',
    desc: '60 páginas con letra grande y clara para leer sin cansancio.'
  }, {
    title: 'Técnicas Anti-Estrés:',
    desc: 'Cómo desbloquear su mente en segundos cuando se sienta "en blanco".'
  }, {
    title: 'El Método ANCLA:',
    desc: 'El paso a paso para no volver a olvidar un nombre o una cita médica.'
  }, {
    title: 'Calendario de 30 Días:',
    desc: 'Un ejercicio de 15 minutos para cada mañana, listo para imprimir.'
  }, {
    title: 'Guía de Nutrición Mental:',
    desc: 'Alimentos de nuestra cocina latina que limpian la "niebla" cognitiva.'
  }];
  return <section className="bg-amber-50 py-16 md:py-24 px-4" data-id="element-163">
      <div className="max-w-3xl mx-auto" data-id="element-164">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-10 text-center" data-id="element-165">
          Todo lo que incluye su Guía
        </h2>
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10" data-id="element-166">
          <ul className="space-y-6" data-id="element-167">
            {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-168">
                <CheckCircleIcon className="w-8 h-8 text-amber-600 mr-4 flex-shrink-0 mt-1" data-id="element-169" />
                <p className="text-lg md:text-xl text-stone-700 leading-relaxed" data-id="element-170">
                  <strong className="text-stone-900" data-id="element-171">{item.title}</strong>{' '}
                  {item.desc}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}